import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { AuthService } from "./auth.service";
import { MeUser } from "./models/me-user";
import { Observable, of, switchMap } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class AuthResolverService implements Resolve<MeUser> {
    constructor(private authService: AuthService) {

    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<MeUser> {
        return this.authService.meSelectSubject.pipe(
            switchMap((user: MeUser | null) => {
                if (user) return of(user);
                return this.authService.me();
            }))
    }
}